export default {
    API_ENDPOINT: 'https://still-stream-35629.herokuapp.com',
    CLIENT_ROOT: 'https://our-health-app.now.sh'

  }
 